import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.correction.editConfirmModal.title',
    defaultMessage: 'SAVE EDITIONS',
  },
  close: {
    id: 'simulated.correction.editConfirmModal.close',
    defaultMessage: 'Close',
  },
  successMessage: {
    id: 'simulated.correction.editConfirmModal.successMessage',
    defaultMessage: 'Response card audited successfully.',
  },
  errorNotFound: {
    id: 'simulated.correction.editConfirmModal.errorNotFound',
    defaultMessage: 'Answer card not found.',
  },
  errorNoUpdate: {
    id: 'simulated.correction.editConfirmModal.errorNoUpdate',
    defaultMessage: 'There are no answers to update.',
  },
  errorGeneric: {
    id: 'simulated.correction.editConfirmModal.errorGeneric',
    defaultMessage: 'An error has occurred, please contact the administrator.',
  },
});
